<a [routerLink]="'/proposta/' + id" class="no-underline">
  <div [ngStyle]="{'background-image': 'url(' + image + ')'}" class="offer-card cover-image">
    <div class="h-full flex flex-column justify-content-center mr-4 ml-4">
      <h3 [ngClass]="{'mb-0': description, 'mb-2': !description}" class="text-white mt-2 mb-0">{{ title }}</h3>
      <!-- TODO: non viene inserito l'allineamento del testo -->
      <p *ngIf="description" class="text-300 mb-2 mt-2" [innerHTML]="description"></p>
      <p *ngIf="expirationDate" [countdown]="expirationDate" class="text-white text-xl mb-2 mt-0"></p>
    </div>
  </div>
</a>